import React from 'react';
import {
    Menu,
    MenuItem,
    Divider,
    Typography
} from '@mui/material';

const BulkActionMenu = ({
                            anchorEl,
                            open,
                            onClose,
                            onUpdateStatus,
                            onAssignStaff,
                            onSchedule,
                            staff = []
                        }) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: 200,
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                }
            }}
        >
            <MenuItem disabled>
                <Typography variant="subtitle2">Change Status</Typography>
            </MenuItem>
            <MenuItem onClick={() => onUpdateStatus('In Progress')}>
                Mark as In Progress
            </MenuItem>
            <MenuItem onClick={() => onUpdateStatus('Scheduled')}>
                Mark as Scheduled
            </MenuItem>
            <MenuItem onClick={() => onUpdateStatus('Resolved')}>
                Mark as Resolved
            </MenuItem>
            <MenuItem onClick={() => onUpdateStatus('Closed')}>
                Mark as Closed
            </MenuItem>

            <Divider sx={{my: 1}}/>

            <MenuItem disabled>
                <Typography variant="subtitle2">Assign To</Typography>
            </MenuItem>
            {staff.map(staffMember => (
                <MenuItem key={staffMember.provider_id} onClick={() => onAssignStaff(staffMember)}>
                    {staffMember.first_name} {staffMember.last_name} - ({staffMember.specialization})
                </MenuItem>
            ))}

           {/* <Divider sx={{my: 1}}/>

            <MenuItem onClick={onSchedule}>
                Schedule Maintenance
            </MenuItem>*/}
        </Menu>
    );
};

export default BulkActionMenu;